let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("efW65")).then(() => parcelRequire('6Opya'));